import { createContext, useContext } from 'react';
import { useAnswerForm } from '../hooks/useAnswerForm';

export const AnswerFormContext = createContext({} as ReturnType<typeof useAnswerForm>);

export const AnswerFormProvider = AnswerFormContext.Provider;

export const useAnswerFormContext = () => useContext(AnswerFormContext);
